import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private injector: Injector,
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            console.log('Handling Error: ', err);

            if (err.status === 500) {
                // void this.showSnackBar('Internal Server Error', 'ERROR');
            } else if (err.status === 401 || err.status === 403) {
                // auto logout if 401 response returned from api
                void this.showSessionExpiredSnackBar();
                this.router.navigate(['/logout']);
            }

            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }

    private async showSessionExpiredSnackBar() {
        const { MatSnackBar } = await import('@angular/material/snack-bar');
        this.injector.get(MatSnackBar).open('Your session has expired', 'Logged Out', { duration: 6000 });
    }
}